import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Roles, RoleSlug } from '@core/Roles';
import { ProfileState } from '@data/profile/profile-state';
import { Store } from '@ngxs/store';
import { NotificationService } from '@shared/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HpxGuard {
  constructor(
    private store: Store,
    private router: Router,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(ProfileState.roles).pipe(
      filter(Boolean),
      map((roles: RoleSlug[]) => roles.some((role) => Roles.hpx().includes(role))),
      map((can: boolean) => {
        if (can) {
          return true;
        }

        this.notificationService.notifyError(
          this.translateService.instant('you-do-not-have-access-to-this-part-of-the-application'),
        );
        return this.router.createUrlTree(['/', this.store.selectSnapshot(ProfileState.routeRolePrefix)]);
      }),
    );
  }
}
